import React, { useState, useRef, useEffect, useMemo } from 'react';
import { View, Text, Image, ScrollView, TouchableOpacity, StyleSheet } from 'react-native';
import { CHEVRON_DOWN, CHEVRON_UP } from '../../assets';
import CustomPressable from '../customPressable/customPressable';
import { useCssStyle } from '../../customHook/getCssStyle';
import Select from 'react-select';

export const CustomDropDown = (props) => {

    const {
        label,
        placeholder = "",
        isRequired,
        options = [],
        selectedOption = null,
        onSelectOption,
        isSearchable = false,
    } = props || {};


    const getStyles = useCssStyle();

    const [selectedOption_localState, setSelectedOptionLocalState] = useState(null);


    useEffect(() => {

        if(options.length > 0 && selectedOption){
            const selectedOption_tempvar = options.find(item => item.value == selectedOption)
            setSelectedOptionLocalState(selectedOption_tempvar);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options, selectedOption])



    const dropdown_web = getStyles(['dropdown_web'])
    const dropdown_web_container = getStyles(['dropdown_web_container'])
    const dropdown_web_container_selected = getStyles(['dropdown_web_container_selected'])

    return (
        <View style={getStyles(['dropdownMaincontainer'])} id="dropdownMaincontainer">
            {label && <Text style={getStyles(['label'])} id="label" >{label} {isRequired && <Text style={getStyles(['requiredText'])} id='requiredText' >*</Text>}</Text>}
            <Select
                className="basic-single"
                options={options}
                value={selectedOption_localState}
                onChange={onSelectOption}
                isSearchable={isSearchable}
                isClearable={false}
                placeholder={placeholder}
                menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                isOptionDisabled={(option) => option.type === 'header'}
                formatOptionLabel={(option) => {
                    if (option.type === 'header') {
                      return (
                        <div style={{ fontWeight: 'bold', fontSize: 15, color: '#777' }}>
                          {option.label}
                        </div>
                      );
                    }
                    return option.label;
                }}
                styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    control: (styles) => ({ ...styles, ...dropdown_web }),
                    option: (styles, { isFocused, isSelected }) => {
                        return {
                            ...styles,
                            ...dropdown_web_container,
                            ...(isSelected && dropdown_web_container_selected),
                        }
                    }
                }}
            />
        </View>
    )
}

export default CustomDropDown;